module.exports = __webpack_public_path__ + "img/shield.8600ba48.svg";